export function validateFormatCanadianPostal(postalCode) {
  // Convert the postal code to uppercase and remove non-alphanumeric characters
  const cleanedPostalCode = (postalCode || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

  // Check if the cleaned postal code has exactly 6 characters
  if (cleanedPostalCode.length !== 6) {
    return { isValid: false, formattedPostalCode: null };
  }

  // Insert a space in the middle to format as A1A 1A1
  const formattedPostalCode = cleanedPostalCode.slice(0, 3) + ' ' + cleanedPostalCode.slice(3);

  // Define the regular expression for a Canadian postal code
  const postalCodePattern = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;

  // Test the formatted postal code against the pattern
  const isValid = postalCodePattern.test(formattedPostalCode);

  return { isValid: isValid, formattedPostalCode: isValid ? formattedPostalCode : null };
}
